import { useAuthActions } from "@/hooks/api/useAuthActions"
import { useAuthStore } from "@/stores/auth"

const isLoggedIn = () => {
  const { isAuthenticated, accessToken } = useAuthStore.getState()
  return isAuthenticated && !!accessToken
}

const useAuth = () => {
  const { user, isAuthenticated } = useAuthStore()
  const {
    login,
    logout: logoutAction,
    register,
    error,
    isLoading,
  } = useAuthActions()

  const signUpMutation = register
  const loginMutation = login

  const logout = async () => {
    await logoutAction()
  }

  return {
    signUpMutation,
    loginMutation,
    logout,
    user,
    error,
    isLoading,
    isAuthenticated,
    resetError: () => login.reset?.(),
  }
}

export { isLoggedIn }
export default useAuth
